// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_hp-1";
export var quotedThread = "_hp-0";